import png from './images/warriors.png'

export const colors = {
  dominant: '#231F20',
  highlight: '#fcb53e',
}
export const fullname = 'Warriors'
export const badge = png



// WEBPACK FOOTER //
// ./src/nrl-teams/warriors.js